import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'Home,', href: '/' },
  { label: 'Gallery,', href: '/gallery' },
  { label: 'Work,', href: '/work' },
  { label: 'Contact', href: '/contact' },
];

export default function PalmerNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-black/95 border-b border-white/10' : 'bg-transparent'
      }`}
      style={{ fontFamily: "'DM Sans', sans-serif" }}
    >
      <nav className="px-6 py-5 flex items-center justify-between">
        {/* Logo / Brand */}
        <Link
          to="/"
          className="text-white font-semibold text-sm tracking-tight hover:opacity-60 transition-opacity whitespace-nowrap"
        >
          Nova AI Digital LLC
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-10">
          {/* Quick links */}
          <div>
            <p className="text-white/30 text-xs mb-1">Quick Links</p>
            <div className="flex items-center gap-0">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-white text-sm hover:opacity-40 transition-opacity whitespace-nowrap mr-2 last:mr-0"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
          {/* Location info */}
          <div className="text-right">
            <p className="text-white/30 text-xs mb-1">Based in New York</p>
            <p className="text-white/30 text-xs">AI &amp; Digital Agency</p>
          </div>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-white w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-black border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="text-white text-lg hover:opacity-40 transition-opacity"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
